import React, { useEffect, useState } from "react";
import MultipleTogglePopup from "./MultipleTogglePopup";
import SelectedMultipleUsersList from "./SelectedMultipleUsersList";
import styled from "styled-components";
import MultipleUsersModal from "./MultipleUsersModal";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import { updateReferrals } from "../../../../utils";

const AddMultipleUsers = ({
  mainParents,
  title,
  icon,
  selPlaceholder,
  setSelectedIds,
  selectedIds,
}) => {
  const { t } = useTranslation();
  const { setFieldValue, values } = useFormikContext();
  const [selectedMainParents, setSelectedMainParents] = useState([]);
  const [showMultipleUsersModal, setShowMultipleUsersModal] = useState(false);

  const handleRemoveClick = (parentId) => {
    // Filter out the removed user
    const selectedUpdate = selectedMainParents.filter(
      (selected) => selected.id !== parentId,
    );

    // Update UI and IDs
    setSelectedMainParents(selectedUpdate);
    setSelectedIds(selectedUpdate.map((x) => x.id));

    if(setFieldValue){
      const updatedReferrals = values.referrals?.filter((ref) => ref.unique_id !== `my_department_${parentId}`);
      setFieldValue('referrals', updatedReferrals);
    }
  };

  const handleAddItems = (newData) => {
    setSelectedMainParents(newData);
    const updatedIds = newData.map((x) => x.id);
    setSelectedIds(updatedIds);

    if(setFieldValue) {
      const referralArray = updateReferrals(newData, 'my_department', values.referrals);
      setFieldValue('referrals', referralArray);
    };
  };

  useEffect(() => {
    if (selectedIds && mainParents.length > 0) {
      const selectedItems =
        mainParents &&
        mainParents.length > 0 &&
        mainParents.filter((item) => selectedIds.includes(parseInt(item.id)));
      setSelectedMainParents(selectedItems);
    }
  }, [selectedIds, mainParents]);

  return (
    <MultipleUsersRow>
      <SelectedMultipleUsersList
        selectedMainParents={selectedMainParents}
        onRemoveClick={handleRemoveClick}
      />
      <MultipleTogglePopup
        icon={icon}
        selPlaceholder={t(selPlaceholder)}
        setShowMultipleUsersModal={setShowMultipleUsersModal}
      />
      <MultipleUsersModal
        title={t(title)}
        show={showMultipleUsersModal}
        onHide={() => setShowMultipleUsersModal(false)}
        mainParents={mainParents}
        selectedMainParents={selectedMainParents}
        setSelectedMainParents={handleAddItems}
      />
    </MultipleUsersRow>
  );
};

export default AddMultipleUsers;

const MultipleUsersRow = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
`;
